import { useCarbarAuAuthStore } from '@/stores/carbar-au-auth'
import { $fetch } from 'ofetch'

/**
 * For the API's /secure/* routes: login, OTP, session and logout. They use the API's session cookie and a
 * CSRF token from the response bodies, not the bearer token. Errors are ofetch's FetchError, with the body in `data`.
 */
export const useFetchForAuth = async (url, options = {}, isRetry = false) => {
	const runtimeConfig = useRuntimeConfig()
	const authStore = useCarbarAuAuthStore()
	const isPost = options.method?.toUpperCase() === 'POST'

	if (isPost && !authStore.csrfToken) {
		await useFetchForAuth('/secure/csrf-token')
	}

	const fetchOptions = usePartnerHeaders({
		...options,
		baseURL: runtimeConfig.public.API_URL,
		credentials: 'include',
		headers: {
			...options.headers,
			Accept: 'application/json',
			...(isPost && { 'X-CSRF-TOKEN': authStore.csrfToken }),
		},
	})

	try {
		const data = await $fetch(
			augmentCarbarUrl(url, runtimeConfig.public.NODE_ENV),
			fetchOptions
		)

		// The token changes on login and logout, so keep the newest
		if (data?.csrf_token) {
			authStore.csrfToken = data.csrf_token
		}

		return data
	} catch (error) {
		// 419 is a stale CSRF token: fetch a new one and retry once
		if (isPost && error?.status === 419 && !isRetry) {
			authStore.csrfToken = null
			return useFetchForAuth(url, options, true)
		}

		throw error
	}
}
